import React from 'react';
import '../styles/MissionPage.css';

const MissionPage = () => {
  const awards = [
    {
      id: 1,
      name: 'DBN Innovation Award Winner',
      image: '/images/dbn.png'
    }
  ];

  const partners = [
    {
      id: 1,
      name: 'Namibia University of Science and Technology',
      image: '/images/Nust.svg'
    },
    {
      id: 2,
      name: 'STS Association',
      image: '/images/sts.gif'
    },
    // {
    //   id: 4,
    //   name: 'MTC Namibia',
    //   image: '/images/mtc.png'
    // },
    {
      id: 5,
      name: 'City of Windhoek',
      image: '/images/CoW.png'
    },
    {
      id: 6,
      name: 'Analog Devices',
      image: '/images/analog_devices.png'
    }
  ];

  return (
    <div className="mission-page-full">
      <div className="mission-page-full__content">
        <div className="mission__content">
          <div className="mission__section">
            <h2 className="mission__title">Our Mission</h2>
            <p className="mission__text">
              Pulsar is a technology company at the forefront of innovation, dedicated to creating solutions that make life simpler and more efficient. Our cutting-edge product, the GRIDx meter, integrates a Wi-Fi router into the smart electricity meter, providing seamless connectivity and data management for individuals and businesses alike.
            </p>
            <p className="mission__text">
              With a particular emphasis on security and privacy, our product offers reliable, high-speed internet connectivity to homes and businesses, while also enabling efficient energy consumption management.
            </p>
            <p className="mission__text">
              At Pulsar, we believe that technology should serve humanity, and we strive to make that a reality with every product and service we offer.
            </p>
          </div>
        </div>

        <div className="mission__featured">
          <div className="mission__featured-content">
            <div className="mission__featured-image">
              <img src="/images/article-thumbnail.jpg" alt="GRIDx Smart Meter Article" />
            </div>
            <div className="mission__featured-text">
              <div className="mission__featured-badge">Featured Article</div>
              <h2 className="mission__featured-title">Pulsar's GRIDx: A Smarter Smart Meter for Sub-Saharan Africa</h2>
              <p className="mission__featured-excerpt">
                Analog Devices highlights how Pulsar is bridging the digital divide by enabling internet access and smart energy metering through a single innovative device designed for sub-Saharan Africa.
              </p>
              <a 
                href="https://www.analog.com/en/signals/articles/pulsar-gridx-smart-meter-sub-saharan.html" 
                target="_blank" 
                rel="noopener noreferrer"
                className="mission__featured-link"
              >
                Read Full Article on Analog.com
                <span className="mission__featured-arrow">→</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mission__partners">
          <h2 className="mission__partners-title">Our Partners</h2>
          <div className="mission__partners-grid">
            {partners.map((partner) => (
              <div key={partner.id} className="mission__partner-card">
                <div className="mission__partner-image">
                  <img src={partner.image} alt={partner.name} />
                </div>
                <p className="mission__partner-name">{partner.name}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mission__awards">
          <h3 className="mission__awards-title">Recognition</h3>
          <div className="mission__awards-grid">
            {awards.map((award) => (
              <div key={award.id} className="mission__award-card">
                <div className="mission__award-image">
                  <img src={award.image} alt={award.name} />
                </div>
                <p className="mission__award-name">{award.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionPage;
